/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
import React from 'react';

const BoxBorderIceberg = (props) => {

    return (
        <div className="boxBorder">
            <svg version="1.1" id="icebergSvg" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 807.8 484.7" enableBackground="new 0 0 807.8 484.7" xmlSpace="preserve" preserveAspectRatio="none">
                <path className="boxBorder__path" id={props.id} fill="none" stroke="#EAEDF2" strokeWidth="5" strokeMiterlimit="10" d="M404.1,481.8h392.6c4.7,0,8.5-3.8,8.5-8.5v-462
                    c0-4.7-3.8-8.5-8.5-8.5H11.1c-4.7,0-8.5,3.8-8.5,8.5v462c0,4.7,3.8,8.5,8.5,8.5H404.1z"/>
            </svg>
        </div>
    );
}

export default BoxBorderIceberg;



// WEBPACK FOOTER //
// ./frontend/pages/LiveMarkets/BoxBorderIceberg.jsx